import TableCell from '@mui/material/TableCell';
import styled from 'styled-components';
import { EditButton } from '../../../../components/Button/editButton';
import { Icon } from '../../../../components/Icon';
import { colors } from '../../../../constants/Colors';
import { FontWeight } from '../../../../constants/Styles/fontWeight';
import { units } from '../../../../helpers/styles/units';

export const styles = {
    root: {
        borderRadius: 0,
        boxShadow: 'none',
        '& .MuiTableHead-root': {
            background: `${colors.grey60}`,
            borderRadius: '0px',
        },
        '& .MuiTableContainer-root': {
            borderRadius: '0px',
        },
        '& .MuiPaper-root': {
            borderRadius: '0px !important',
        },

        '& . MuiTableCell-root': {
            borderBottom: '0',
        },
    },
    body: {
        '& .MuiTableRow-root:hover': {
            backgroundColor: `${colors.white}`,
        },
        '& .text-grey': {
            color: `${colors.grey20}`,
            maxWidth: `${units(112)}`,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            position: 'relative',
        },
        '& .cell-medium': {
            fontWeight: FontWeight.BOLD,
        },
    },
};

export const StyledEditButton = styled(EditButton)`
  margin: 0;
`;

export const StyledReloadIcon = styled(Icon)`
    cursor: pointer;
`;

export const StyledCell = styled(TableCell)`
  .status {
    display: flex;
    padding: ${units(2)} ${units(6)};
    align-items: center;
    gap: ${units(4)};
  }

  & .active {
    background-color: rgba(87, 198, 118, 0.05);

    & div {
      background-color: ${colors.green};
    }
  }

  & .end {
    background-color: rgba(231, 72, 72, 0.05);

    & div {
      background-color: ${colors.red};
    }
  }

  & .plan {
    background-color: rgba(215, 180, 106, 0.05);

    & div {
      background-color: ${colors.gold};
    }
  }
`;
